import { Injectable, signal } from '@angular/core';

export interface HttpLogEntry {
  method: string;
  url: string;
  status: number;
  ms: number;
  at: Date;
  error: boolean;
}

/** Rolling buffer of recent HTTP calls, newest first — the right-top debug panel. */
@Injectable({ providedIn: 'root' })
export class HttpLogService {
  readonly entries = signal<HttpLogEntry[]>([]);

  add(method: string, url: string, status: number, ms: number, error = false): void {
    const entry: HttpLogEntry = { method, url, status, ms: Math.round(ms), at: new Date(), error };
    this.entries.update((list) => [entry, ...list].slice(0, 100));
  }
}
